import { baseApi } from '../baseApi';
import { EvaluationModel } from '../../models/evaluationModel';

export async function createEvaluationReq(evaluation: EvaluationModel) {
  const data = new FormData();
  if (evaluation.file && evaluation.file instanceof File) data.append('file', evaluation.file);

  //Do not serialize file blob
  data.append('evaluation', JSON.stringify(evaluation, replacer));
  function replacer(key: string, value: any) {
    if (key === 'file') return undefined;
    else return value;
  }

  return baseApi.post<EvaluationModel>('/officiating/evaluation/edit', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteEvaluationReq(evaluationId: string) {
  return baseApi.delete(`/officiating/evaluation/edit/${evaluationId}`);
}
